import {
  backOfficeProformaInvoiceConfirmFetch,
  backOfficeProformaInvoicesViewFetch,
} from '@Redux/slices/account/backOfficeInvoiceSlice';
import Card from '@Utils/Card';
import { Button, DatePicker, Input, Modal } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import classes from './BackOfficeProformaInvoiceDetails.module.less';
import { history } from '../../../../redux/store';

function InputItem(props) {
  return (
    <div className={classes['invoice-form-item']}>
      <label>{props.label}</label>
      <Input
        className={classes['invoice-input']}
        value={props.value}
        pattern="/\d+/"
        disabled={!props.editable}
        onChange={(event) => props.onChange?.(event.target.value)}
      />
    </div>
  );
}

function DateItem(props) {
  return (
    <div className={classes['invoice-form-item']}>
      <label>
        <div className={classes['editable-label']}>{props.label}</div>
      </label>
      <DatePicker
        className={classes['invoice-input']}
        disabled
        showTime
        value={moment(props.value)}
      />
    </div>
  );
}

function BackOfficeProformaInvoiceDetails(props) {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [editable, setEditable] = useState(false);

  const id = props.match.params?.id;

  const loading = useSelector((state) => state.account.backOffice.loading);

  const confirming = useSelector(
    (state) => state.account.backOffice.confirming
  );

  const details = useSelector(
    (state) => state.account.backOffice.proformaInvoiceDetails
  );

  const [{ basePrice, perMilEventsPrice }, setMutableData] = useState({
    basePrice: details?.basePriceDetails?.price,
    perMilEventsPrice: details?.perMilEventsPrice,
  });

  const refetchInvoices = useCallback(() => {
    if (id) dispatch(backOfficeProformaInvoicesViewFetch(id));
  }, [id]);

  const onCancelEditing = useCallback(() => {
    setMutableData({
      basePrice: details?.basePriceDetails?.price,
      perMilEventsPrice: details?.perMilEventsPrice,
    });
  }, [details]);

  useEffect(() => {
    if (!editable) onCancelEditing();
  }, [editable, onCancelEditing]);

  useEffect(() => {
    if (details) {
      setMutableData({
        basePrice: details?.basePriceDetails?.price,
        perMilEventsPrice: details?.perMilEventsPrice,
      });
    }
  }, [details]);

  useEffect(() => {
    refetchInvoices();
  }, [refetchInvoices]);

  return (
    <Card loading={loading} styles={{ minHeight: loading ? 444 : 'unset' }}>
      <div className={classes['invoice-container']}>
        <div className={classes['invoice-wrapper']}>
          <DateItem label="Created Date" value={details?.createdDate} />
          <DateItem label="Start Date" value={details?.startDate} />
          <DateItem label="End Date" value={details?.endDate} />
          <InputItem label="MAU Count" value={details?.mauCount} />
          <InputItem label="Events Count" value={details?.eventsCount} />
          <InputItem
            label="Per Million Price"
            editable={editable}
            value={perMilEventsPrice}
            onCancelEditing={() => {
              if (
                typeof perMilEventsPrice === 'undefined' ||
                perMilEventsPrice === ''
              ) {
                setMutableData((prev) => ({
                  ...prev,
                  perMilEventsPrice: details?.perMilEventsPrice,
                }));
              }
            }}
            onChange={(perMilEventsPrice) => {
              setMutableData((prev) => ({ ...prev, perMilEventsPrice }));
            }}
          />
          <InputItem
            label="Base Price"
            editable={editable}
            value={basePrice}
            onCancelEditing={() => {
              if (typeof basePrice === 'undefined' || basePrice === '') {
                setMutableData((prev) => ({
                  ...prev,
                  basePrice: details?.basePriceDetails?.price,
                }));
              }
            }}
            onChange={(basePrice) => {
              setMutableData((prev) => ({ ...prev, basePrice }));
            }}
          />
          <InputItem label="Total VAT" value={details?.totalVat} />
          <InputItem label="Final Price" value={details?.finalPrice} />
        </div>
        <div className={classes['invoice-edit-btn']}>
          <Button type="primary" onClick={() => setEditable((prev) => !prev)}>
            {editable ? 'Cancel' : 'Edit'}
          </Button>
        </div>
      </div>
      <div className={classes['invoice-action']}>
        <Button
          onClick={() => setIsModalOpen(true)}
          type="primary"
          style={{ minWidth: 100 }}
        >
          Submit
        </Button>
      </div>
      <Modal
        open={isModalOpen}
        confirmLoading={confirming}
        okText="Confirm"
        cancelText="Cancel"
        onOk={() => {
          if (typeof details?.crc === 'undefined' || details?.crc === null) {
            return;
          }

          dispatch(
            backOfficeProformaInvoiceConfirmFetch(
              id,
              {
                basePrice: Number(basePrice),
                perMilEventsPrice: Number(perMilEventsPrice),
                crc: details?.crc,
              },
              () => {
                refetchInvoices();
                history.push('/back-office/invoice/?tab=proforma');
              }
            )
          );
          setEditable(false);
          setIsModalOpen(false);
        }}
        onCancel={() => setIsModalOpen(false)}
      >
        Please note that only one submission is allowed. Are you sure you want
        to apply the changes?
      </Modal>
    </Card>
  );
}

export default BackOfficeProformaInvoiceDetails;
